/**
 * Created by shubham on 27/2/18.
 */

import { Component } from '@angular/core';
import { SessionHandler } from '../shared/services/session-handler.service';
import { HttpService } from '../shared/services/http.service';
import { LayoutService } from '../layout/layout.service';
import { APPCONFIG } from '../config';
import { MdDialog } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from 'ng2-translate';
import { CommonService } from '../shared/services/common.service';
import {isNullOrUndefined} from "util";
declare const gapi: any;

@Component({
    selector: 'app-login',
    styles: [],
    template: require('./login.component.html'),
    providers: []
})

export class LoginComponent {
    dialogRef;
    userDetails:any;
    PartnersForm: FormGroup;
    PartnersFormDetails: any;
    defaultLanguageId: any;
    languageDetails: any;
    urlId: any;
    redirectUrl: string = "";

    constructor(private dialog: MdDialog,private router: Router, private route: ActivatedRoute,public layoutService: LayoutService,public httpService: HttpService,
                public sessionHandler: SessionHandler, private formBuilder: FormBuilder, private translate: TranslateService, public commonService:CommonService){
        this.PartnersFormDetails = [];

        //Get URL param value
        this.route.params.subscribe(params => {
            this.urlId = params['id'];
            if(this.urlId != undefined){
                this.urlId = this.urlId.toUpperCase();
            }
        });

        this.redirectUrl = this.commonService.getLoginRedirectUrl();
        //this.redirectUrl = this.sessionHandler.getItem('lastUrl');
        console.log(this.redirectUrl);

        this.getLanguages();
    }

    //Initialize Google Login API
    public auth2: any;
    public googleInit() {
        let that = this;
        gapi.load('auth2', function () {
            that.auth2 = gapi.auth2.init({
                client_id: APPCONFIG.google_client_id,
                cookiepolicy: 'single_host_origin',
                scope: 'profile email'
            });
            that.attachSignin(document.getElementById('googleBtn'));
        });
    }

    //Attach Click Handler for Google Login
    public attachSignin(element) {
        let that = this;
        this.auth2.attachClickHandler(element, {},
            function (googleUser) {
                that.adminLogin(googleUser);
            },
            function (error) {
                console.log(JSON.stringify(error, undefined, 2));
            });
    }

    //Google Login Post API
    adminLogin(googleUser) {
        let profile = googleUser.getBasicProfile();
        this.userDetails = {
            token: googleUser.getAuthResponse().id_token,
            name: profile.getName(),
            image: profile.getImageUrl(),
            email: profile.getEmail(),
            languageId: this.PartnersFormDetails.languageId
        };
        if(this.userDetails.email){
            this.httpService.postRequest(this.userDetails,'userOperationsApi/v1/googleLogin').subscribe(
                res => { this.saveGoogleResponse(res); },
                err => { this.httpService.onEnd(); }
            );
        } else {
            this.layoutService.popToast("Invalid Email Domain.", APPCONFIG.toastrType.error);
        }
    }

    //Save Response of Google Login API
    public saveGoogleResponse(res){
        if(res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            alert('User is not authorized');
        } else {
            if(res){
                this.sessionHandler.saveItem("loginData", JSON.stringify(res));
                if(res.languageId){
                    this.setLanguage(res.languageId);
                } else {
                    this.setLanguage('EN');
                }

                let redirectUrl;

                this.sessionHandler.saveItem("userDetails", JSON.stringify(this.userDetails));
                if(res.roleCode.includes(APPCONFIG.systemAdmin)){
                    redirectUrl = '#/app/profile';
                } else if(res.roleCode.includes(APPCONFIG.BUManager) || res.roleCode.includes(APPCONFIG.regionalAdmin)){
                    redirectUrl = '#/app/admin-dashboard';
                } else if(res.roleCode.includes(APPCONFIG.applicationManager)){
                    redirectUrl = '#/app/application-manager-dashboard';
                } else{
                    alert('No role assigned to user. Please contact your administrator.');
                    redirectUrl = '#/login';
                }

                if(this.redirectUrl != "" && this.redirectUrl != undefined && this.redirectUrl != null){
                    redirectUrl = this.redirectUrl;
                }

                this.httpService.onEnd();
                window.location.href = redirectUrl;
            }
        }
    }

    //DigiAccess Login
    public digiAccessLogin() {
        if(this.PartnersFormDetails.userId_WPASS){
            this.httpService.postRequest(this.PartnersFormDetails,'userOperationsApi/v1/digiAccessLogin').subscribe(
                res => { this.saveResponse(res); },
                err => {
                    this.PartnersForm.reset();
                    this.getLanguages();
                    this.httpService.onEnd();
                }
            );
        } else {
            this.layoutService.popToast("Invalid Email Domain.", APPCONFIG.toastrType.error);
        }
    }

    //Save Response of DigiAccess Login API
    public saveResponse(res){
        let selectedLogin = res.userType;
        if(res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            if(selectedLogin == 'PARTNER'){
                this.PartnersForm.reset();
                this.getLanguages();
            }
            alert('User is not authorized');
        } else {
            if(res){

                this.sessionHandler.saveItem("loginData", JSON.stringify(res));
                if(res.languageId){
                    this.setLanguage(res.languageId);
                } else {
                    this.setLanguage('EN');
                }

                let redirectUrl;
                if(selectedLogin == "EMPLOYEE"){
                    this.sessionHandler.saveItem("userDetails", JSON.stringify(this.PartnersFormDetails));
                    if(res.roleCode.includes(APPCONFIG.systemAdmin)){
                        redirectUrl = '#/app/profile';
                    } else if(res.roleCode.includes(APPCONFIG.BUManager) || res.roleCode.includes(APPCONFIG.regionalAdmin)){
                        redirectUrl = '#/app/admin-dashboard';
                    } else if(res.roleCode.includes(APPCONFIG.applicationManager)){
                        redirectUrl = '#/app/application-manager-dashboard';
                    } else{
                        alert('No role assigned to user. Please contact your administrator.');
                        redirectUrl = '#/login';
                    }

                    if(this.redirectUrl != "" && this.redirectUrl != undefined && this.redirectUrl != null){
                        redirectUrl = this.redirectUrl;
                    }
                } else if(selectedLogin == "PARTNER"){
                    this.sessionHandler.saveItem("userDetails", JSON.stringify(this.PartnersFormDetails));
                    if(res.roleCode.includes(APPCONFIG.serviceOwner) || res.roleCode.includes(APPCONFIG.tradePartner)){
                        redirectUrl = '#/app/partners-dashboard';
                        this.sessionHandler.saveItem("wpassLogin", true);
                    } else if(res.roleCode.includes(APPCONFIG.subuser)){
                        redirectUrl = '#/app/profile';
                    } else{
                        alert('No role assigned to user. Please contact your administrator.');
                        redirectUrl = '#/login';
                    }
                }
                this.httpService.onEnd();
                window.location.href = redirectUrl;
            }
        }
    }

    //Get Languages Details
    public getLanguages(){
        this.httpService.getRequest('lookupDataOperationsApi/v1/language').subscribe(
            res => { this.saveLanguageResponse(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    //Save Languages Response
    public saveLanguageResponse(res) {
        if(res && res.items){
            this.languageDetails = res.items;
            let localStorageLanguageId = this.sessionHandler.getItem('languageId');
            for(let l in this.languageDetails){
                if(this.urlId != undefined && this.urlId != null){
                    if(this.languageDetails[l]['id'] == this.urlId){
                        this.setLanguage(this.urlId);
                        this.PartnersForm.controls['languageId'].setValue(this.urlId);
                    }
                } else if(localStorageLanguageId != undefined && localStorageLanguageId != null){
                    if(this.languageDetails[l]['id'] == localStorageLanguageId){
                        this.setLanguage(localStorageLanguageId);
                        this.PartnersForm.controls['languageId'].setValue(localStorageLanguageId);
                    }
                } else {
                    if(this.languageDetails[l]['id'] == 'EN'){
                        this.defaultLanguageId = this.languageDetails[l]['id'];
                        this.setLanguage(this.defaultLanguageId);
                    }
                }
            }
        }
        this.httpService.onEnd();
    }

    showPassword(input: any): any {
        input.type = input.type === 'password' ?  'text' : 'password';
    }

    //Build Form
    buildForm() {
        this.PartnersForm = this.formBuilder.group({
            languageId: this.formBuilder.control(this.urlId),
            userId_WPASS: this.formBuilder.control(null, [Validators.required]),
            password: this.formBuilder.control(null, [Validators.required])
        });
        this.PartnersForm.valueChanges.subscribe(data => {
            this.PartnersFormDetails = this.PartnersForm.getRawValue();
            if(this.PartnersFormDetails.languageId != null){
                this.setLanguage(this.PartnersFormDetails.languageId);
            }
        });
    }

    public setLanguage(languageId){
        this.sessionHandler.saveItem("languageId", languageId);
        this.translate.setDefaultLang(languageId);
        this.translate.use(languageId);
    }

    //Initialize buildForm() function when Login Component loads
    ngOnInit(): void {
       this.buildForm();
    }

    //Initialize googleInit() function after viewPartners initialize
    ngAfterViewInit(){
        this.googleInit();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/login/login.component.ts